import { ReactNode } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { useIsCoApplicantEnabled } from "@lending/hooks/useIsCoApplicantEnabled";

interface CoApplicantGuardProps {
  productType: "personal_loans" | "credit_cards" | "vehicle_loans";
  fallbackPath: string;
  children?: ReactNode;
}

function CoApplicantGuard({ productType, fallbackPath, children }: CoApplicantGuardProps) {
  const isCoApplicantEnabled = useIsCoApplicantEnabled(productType);
  const { applicationUuid } = useParams<{ applicationUuid: string }>();

  const resolvedFallbackPath = applicationUuid
    ? fallbackPath.replace(":applicationUuid", applicationUuid)
    : fallbackPath;

  if (!isCoApplicantEnabled) {
    return <Navigate to={resolvedFallbackPath} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}

export { CoApplicantGuard };
